import { AccommodationBookingGroupPageContentResponseModel } from '@shared/integrations/umbraco-taf-delivery-api/models';
import BookingObjectsListChildren from '@my-pages/features/object-booking/components/BookingObjectsListChildren.tsx';

interface IAccommodationBookingGroupPage {
    content: AccommodationBookingGroupPageContentResponseModel;
}

const AccommodationBookingGroupPage = ({ content }: IAccommodationBookingGroupPage) => {
    return (
        <>
            <h1 className='page-title'>{content.name}</h1>
            {content.id ? <BookingObjectsListChildren contentId={content.id} /> : null}
        </>
    );
};

export default AccommodationBookingGroupPage;
